import {
  LuActivity, LuArchive, LuBuilding, LuCalendar, LuCalendarClock, LuCalendarPlus, LuCalendarRange,
  LuChartBar, LuChartColumn, LuCirclePlus, LuColumns3, LuDatabase, LuFileText, LuFilter, LuInfo,
  LuKanban, LuLayoutGrid, LuListTodo, LuMailPlus, LuPackage, LuPlay, LuRepeat, LuSearch,
  LuSlidersHorizontal, LuTarget, LuTrendingUp, LuTrophy, LuUserPlus, LuUsers, LuWorkflow,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Pages that render nothing but a spinner until their data arrives get a
// longer wait on step 1 so a slow load doesn't end the tour.
const slow = { timeout: 10000 };

// Landing-tab tour first; one tour per further tab below it.
// /crm/dashboard renders the same CRMDashboard, so the landing tour covers it.
const tours = [
  tour('crm', '/crm', 'partner', [
    ['tabs', 'crm.tabs', LuTrendingUp],
    ['period', 'crm.period', LuCalendar, opt],
    ['kpis', 'crm.kpis', LuChartColumn, opt],
    ['deals', 'crm.deals', LuTarget, { placement: 'top', ...opt }],
  ]),

  // Tasks ▾
  tour('crm_tasks', '/crm/tasks', 'partner', [
    ['new', 'crm_tasks.new', LuCirclePlus, { placement: 'left' }],
    ['filters', 'crm_tasks.filters', LuFilter],
    ['list', 'crm_tasks.list', LuListTodo, { placement: 'top' }],
  ], { exact: true }),
  tour('crm_activities', '/crm/activities', 'partner', [
    ['filters', 'crm_activities.filters', LuFilter],
    ['kpis', 'crm_activities.kpis', LuChartColumn],
    ['list', 'crm_activities.list', LuActivity, { placement: 'top' }],
  ], { exact: true }),

  // Contacts (the shared contact list, embedded)
  tour('crm_contacts', '/crm/contacts', 'partner', [
    ['filters', 'contacts.filters', LuSlidersHorizontal],
    ['create', 'crm_contacts.create', LuUserPlus, { placement: 'left', ...opt }],
    ['list', 'contacts.list', LuLayoutGrid, { placement: 'top', ...opt }],
  ], { exact: true }),

  // Sales ▾
  tour('crm_leads', '/crm/leads', 'partner', [
    ['create', 'crm_leads.create', LuUserPlus, { placement: 'left' }],
    ['search', 'crm_leads.search', LuSearch],
    ['list', 'crm_leads.list', LuUsers, { placement: 'top' }],
  ], { exact: true }),
  tour('crm_opportunities', '/crm/opportunities', 'partner', [
    ['views', 'crm_opportunities.views', LuColumns3, slow],
    ['board', 'crm_opportunities.board', LuKanban, { placement: 'top', ...opt }],
  ], { exact: true }),
  // PartnerList is shared with Contacts > Accounts; the targets live there.
  tour('crm_accounts', '/crm/accounts', 'partner', [
    ['search', 'contacts_accounts.search', LuSearch],
    ['list', 'contacts_accounts.list', LuBuilding, { placement: 'top' }],
  ], { exact: true }),
  tour('crm_forecasting', '/crm/forecasting', 'partner', [
    ['period', 'crm_forecasting.period', LuCalendarRange],
    ['new', 'crm_forecasting.new', LuCirclePlus, { placement: 'left' }],
    ['views', 'crm_forecasting.views', LuTrendingUp, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('crm_contracts', '/crm/contracts', 'partner', [
    ['new', 'crm_contracts.new', LuCirclePlus, { placement: 'left' }],
    ['list', 'crm_contracts.list', LuFileText, { placement: 'top' }],
  ], { exact: true }),

  // Reports ▾
  tour('crm_reports', '/crm/reports', 'partner', [
    ['object', 'crm_reports.object', LuDatabase],
    ['fields', 'crm_reports.fields', LuSlidersHorizontal, { placement: 'top' }],
    ['run', 'crm_reports.run', LuPlay, { placement: 'top' }],
  ], { exact: true }),
  tour('crm_revenue', '/crm/revenue', 'partner', [
    ['kpis', 'crm_revenue.kpis', LuChartColumn, slow],
    ['trend', 'crm_revenue.trend', LuChartBar],
    ['reps', 'crm_revenue.reps', LuTrophy, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('crm_mrr', '/crm/mrr', 'partner', [
    ['kpis', 'crm_mrr.kpis', LuRepeat, slow],
    ['trend', 'crm_mrr.trend', LuChartBar],
    ['accounts', 'crm_mrr.accounts', LuBuilding, { placement: 'top', ...opt }],
  ], { exact: true }),
  tour('crm_scheduler', '/crm/scheduler', 'partner', [
    ['new', 'crm_scheduler.new', LuCalendarPlus, { placement: 'left' }],
    ['views', 'crm_scheduler.views', LuCalendarClock],
    ['pages', 'crm_scheduler.pages', LuLayoutGrid, { placement: 'top', ...opt }],
  ], { exact: true }),

  // Config ▾
  tour('crm_products', '/crm/products', 'partner', [
    ['create', 'crm_products.create', LuCirclePlus, { placement: 'left' }],
    ['list', 'crm_products.list', LuPackage, { placement: 'top' }],
  ], { exact: true }),
  tour('crm_assignment_rules', '/crm/assignment-rules', 'partner', [
    ['new', 'crm_assignment_rules.new', LuWorkflow, { placement: 'left' }],
    ['how', 'crm_assignment_rules.how', LuInfo],
  ], { exact: true }),
  tour('crm_teams', '/crm/teams', 'partner', [
    ['new', 'crm_teams.new', LuUsers, { placement: 'left' }],
    ['archived', 'crm_teams.archived', LuArchive, { placement: 'left' }],
  ], { exact: true }),
  tour('crm_sequences', '/crm/sequences', 'partner', [
    ['new', 'crm_sequences.new', LuMailPlus, { placement: 'left' }],
    ['views', 'crm_sequences.views', LuFilter],
  ], { exact: true }),
];

export default tours;
